import React from 'react';
import { Container, Grid, Paper } from '@material-ui/core';
import HOCLoader from 'Components/Loader/HOCLoader';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
const CustomContainer = HOCLoader(Container);

export const Complaint = () => {
    const classes = commonStyle();
    return (
        <CustomContainer>
            <Paper className={classes.PaperStyle}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        Coming Soon...........
                    </Grid>
                </Grid>
            </Paper>
        </CustomContainer>
    );
};
